// The Chrome extension reads the user's login from these cookies, so they must live as long as
// the token they carry. A shorter expiry logs the extension out while the token is still valid.
const AUTH_COOKIE_NAMES = ["fp_email", "fp_user_type", "fp_user_trial_end_date", "eai_token"];
const FALLBACK_LIFETIME_MS = 30 * 24 * 60 * 60 * 1000;

/**
 * Reads the expiry from a JWT
 * @param {string} token jwt token
 * @return {Date|null} when the token expires, or null if it can't be read
 */
export const getTokenExp = (token) => {
  try {
    const { exp } = JSON.parse(window.atob(token.split(".")[1]));
    return exp ? new Date(exp * 1000) : null;
  } catch (e) {
    return null;
  }
};

/**
 * Writes the cookies the extension uses to detect the logged in user
 * @param {object} user of the form {"email", "group", "trial_end_date"}
 * @param {string} token jwt token
 */
export const setAuthCookies = (user, token) => {
  const exp = getTokenExp(token) || new Date(Date.now() + FALLBACK_LIFETIME_MS);
  const expires = "expires=" + exp.toUTCString();

  document.cookie = "fp_email=" + user.email + ";" + expires + "; path=/";
  document.cookie = "fp_user_type=" + user.group + ";" + expires + "; path=/";
  document.cookie = "fp_user_trial_end_date=" + user.trial_end_date + ";" + expires + "; path=/";
  document.cookie = "eai_token=" + token + ";" + expires + "; path=/";
};

/**
 * Removes the login cookies so the extension logs out with the app
 */
export const clearAuthCookies = () => {
  AUTH_COOKIE_NAMES.forEach((name) => {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
  });
};
